import React from "react";
import { ReactComponent as LoadingIcon } from "../../assets/icons/loading.svg";

type Props = {
  loadingText?: string;
};

//temporary name, component 'loading' already exists
const LoadingSpinner = (props: Props) => {
  return (
    <div className="loading-spinner-container">
      <div className="loading-icon-container">
        <LoadingIcon className="loading-icon"></LoadingIcon>
      </div>
      {props.loadingText && (
        <div className="loading-text">{props.loadingText}</div>
      )}
    </div>
  );
};

export default LoadingSpinner;
